import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';

export const checkAccessByFeature = (
  currentFeatures: UserPlanFeature[] = [],
  requiredFeature: UserPlanFeature,
): boolean => {
  return currentFeatures.includes(requiredFeature);
};
